import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@assets/icons/SaveState/SaveUnchanged.svg'
import _imports_1 from '@assets/icons/SaveState/SaveSuccess.svg'
import _imports_2 from '@assets/icons/SaveState/SaveError.svg'


const _hoisted_1 = { class: "save-state-container" }
const _hoisted_2 = {
  class: "save-state-content",
  "data-cy": "save-state-unsaved"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "save-state-content-icon",
  src: _imports_0
}, null, -1)
const _hoisted_4 = {
  class: "save-state-content",
  "data-cy": "save-state-saved"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "save-state-content-icon",
  src: _imports_1
}, null, -1)
const _hoisted_6 = {
  class: "save-state-content",
  "data-cy": "save-state-saving"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "save-state-content-icon",
  src: _imports_2
}, null, -1)

import { useSaveState } from "@common/composable/useRootStore";
import { ApiErrorData } from "@medapro-types/common/common";
import { AxiosError } from "axios";
import _ from "lodash";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import Icon from "./Icon.vue";
import Spinner from "./Spinner.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SaveState',
  setup(__props) {

const { saveState, saveStateMeta } = useSaveState();
const { t: $t } = useI18n();

const isShownErrorsModal = ref(false);

const showErrorsModal = () => {
  isShownErrorsModal.value = true;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const isConflictError = (e: unknown): e is ApiErrorData => {
  return !!e && Object.hasOwn(e, "error") && Object.hasOwn(e, "value") && Object.hasOwn(e, "message");
};

const getErrorMessage = (error: unknown) => {
  if (!_.isString(error) && error instanceof Error) {
    if (error instanceof AxiosError) {
      const responsData: unknown = error.response?.data;
      if (error.status == 409 && isConflictError(responsData)) {
        return responsData.message ? responsData.message : $t(`error.${responsData.error}`, { prop: responsData.value });
      } else {
        return responsData;
      }
    } else {
      error.message;
    }
    return "";
  }
  return error;
};

const errorList = computed(() => {
  return _.chain(saveStateMeta.value.errors.map((x) => getErrorMessage(x)))
    .uniq()
    .compact()
    .value();
});

return (_ctx: any,_cache: any) => {
  const _component_b_btn = _resolveComponent("b-btn")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["save-state", _unref(saveState)]),
      "data-cy": "save-state"
    }, [
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(`${_unref($t)("saveState.unsaved")}`), 1)
      ], 512), [
        [_vShow, _unref(saveState) == 'unsaved']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(`${_unref($t)("saveState.saved")}!`), 1)
      ], 512), [
        [_vShow, _unref(saveState) == 'saved']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_6, [
        _createVNode(Spinner, { size: "24" }),
        _createTextVNode(" " + _toDisplayString(`${_unref($t)("saveState.saving")}...`), 1)
      ], 512), [
        [_vShow, _unref(saveState) == 'saving']
      ]),
      _withDirectives(_createVNode(_component_b_btn, {
        variant: "link",
        class: "btn-with-icon save-state-content",
        "data-cy": "save-state-error",
        onClick: showErrorsModal
      }, {
        default: _withCtx(() => [
          _hoisted_7,
          _createTextVNode(" " + _toDisplayString(`${_unref($t)("saveState.error")}`), 1)
        ]),
        _: 1
      }, 512), [
        [_vShow, _unref(saveState) == 'error']
      ])
    ], 2),
    _createVNode(_component_b_modal, {
      size: "lg",
      "body-class": "save-state-errors-modal",
      title: _unref($t)('saveState.errorsModalTitle'),
      modelValue: isShownErrorsModal.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isShownErrorsModal).value = $event)),
      "header-close-content": "",
      centered: "",
      "ok-only": ""
    }, {
      default: _withCtx(() => [
        _createVNode(Icon, {
          icon: "Error",
          size: "32px"
        }),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errorList.value, (error) => {
            return (_openBlock(), _createElementBlock("li", {
              key: error?.toString(),
              class: "error-entry"
            }, _toDisplayString(error), 1))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]))
}
}

})